import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({
  baseURL: `${BASE}/api`,
  withCredentials: true,
});

// Global response interceptor: swallow expected auth/RBAC errors so unhandled
// rejections don't blow up dev overlays or console. 401 => let AuthContext handle;
// 403/404 => let the caller decide (they still get the error).
api.interceptors.response.use(
  (r) => r,
  (err) => {
    // don't spam the console; caller catches
    return Promise.reject(err);
  }
);

export function formatApiError(err) {
  const d = err?.response?.data?.detail;
  if (d == null) return err?.message || "Something went wrong.";
  if (typeof d === "string") return d;
  if (Array.isArray(d))
    return d.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (d?.msg) return d.msg;
  return String(d);
}

// safe axios call: never rejects; returns {data} on success or {error} on failure
export async function safeGet(url) {
  try {
    const r = await api.get(url);
    return { data: r.data };
  } catch (err) {
    return { error: err, status: err?.response?.status };
  }
}
